import React from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { useTimezone } from 'libs/hooks';
import { TRecruitment } from 'modules/main';
import { CDateTimeFormat } from 'constants/base.const';
import { ERecruitmentCategory } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Avatar, Col, Row, Card } from 'antd';
import { RightOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { PrimaryColor, LightGrayColor } from 'GlobalStyles';
import BigstepLogoSource from 'assets/images/logos/CSBigLogo.webp';

export const CardWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: block;
  position: relative;
  margin-bottom: 32px;

  .ant-card {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
  }
  .ant-card-cover {
    position: relative;
  }
  .ant-card-bordered {
    border: 1px solid ${LightGrayColor};
  }
  .ant-avatar-square {
    border-radius: 8px 8px 0px 0px;
    width: 100%;
    height: 160px;
  }
  .opacity-background {
    background: #000;
    position: absolute;
    z-index: 10;
    opacity: 0.75;
  }
  .center-text {
    position: absolute;
    top: 80px;
    left: 50%;
    z-index: 20;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 32px;
    font-weight: bold;
  }
  .ant-avatar > img {
    max-height: 160px;
  }

  .ant-card-body {
    font-size: 14px;
    background-color: #fff;
    width: 100%;
    padding: 16px;
    .ant-row {
      flex-flow: row nowrap;
    }
  }

  .ant-card-meta-title {
    font-size: 14px;
    font-weight: bold;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-line-clamp: 1;
    word-break: break-word;
    white-space: normal;
    line-height: 20px;
    overflow: hidden;
  }

  .action {
    width: 100%;
    height: 32px;
    line-height: 32px;
    color: ${PrimaryColor};
    font-size: 14px;
    border-radius: 0px 0px 8px 8px;
    .ant-row {
      background-color: ${LightGrayColor};
      padding: 0px 16px;
    }
  }
  .action:hover {
    font-weight: bold;
  }
  .card-value {
    font-size: 13px;
    line-height: 22px;
    text-align: right;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-line-clamp: 1;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
  }
`;

const { Meta } = Card;
type TRecruitmentCardProps = {
  data: TRecruitment;
  showFulltime?: boolean;
};

const FulltimeRecruitmentCard = ({ data, showFulltime = false }: TRecruitmentCardProps) => {
  const [getDateTime, timezone] = useTimezone();
  const baseUrl =
    data?.category === ERecruitmentCategory.Fulltime
      ? ERoute.CompanyFulltimeView
      : ERoute.CompanyTurnOverView;
  const logoUrl =
    data?.category === ERecruitmentCategory.Fulltime
      ? get(data, 'logo_url')
      : get(data, 'logo_url')
      ? get(data, 'logo_url')
      : BigstepLogoSource;
  const cardTitle =
    data?.category === ERecruitmentCategory.Fulltime
      ? get(data, 'title')
      : `[${get(data, 'company_name')}] ${get(data, 'title')}`;

  return (
    <CardWrapper>
      <Card
        cover={
          <Link to={`${baseUrl.replace(':record_id', String(get(data, 'id')))}`}>
            {get(data, 'is_closed', false) === true && (
              <>
                <div className='center-text'>모집 마감</div>
                <div className='ant-avatar-square opacity-background'></div>
              </>
            )}
            <Avatar shape='square' src={logoUrl} />
          </Link>
        }
      >
        <Meta
          title={
            <Link to={`${baseUrl.replace(':record_id', String(get(data, 'id')))}`}>
              <div style={{ color: '#000' }}>{cardTitle}</div>
            </Link>
          }
          description={
            <>
              {showFulltime === true && (
                <Row justify='space-between'>
                  <Col style={{ color: `${PrimaryColor}` }}>정규직 채용</Col>
                </Row>
              )}
              <Row justify='space-between'>
                <Col flex='70px' style={{ color: '#14112A' }}>
                  채용직급
                </Col>
                <Col flex='auto' className='card-value'>
                  {get(data, 'position')}
                </Col>
              </Row>
              <Row justify='space-between'>
                <Col flex='70px' style={{ color: '#14112A' }}>
                  서류기한
                </Col>
                {get(data, 'recruitment_to') ? (
                  <Col flex='auto' className='card-value'>
                    {getDateTime(get(data, 'recruitment_to'))
                      .format(CDateTimeFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                    &nbsp;마감
                  </Col>
                ) : (
                  <Col flex='auto' className='card-value'>
                    ASAP
                  </Col>
                )}
              </Row>
            </>
          }
        />
      </Card>
      <Link to={`${baseUrl.replace(':record_id', String(get(data, 'id')))}`} className='action'>
        <Row justify='space-between'>
          <Col>더보기</Col>
          <Col>
            <RightOutlined />
          </Col>
        </Row>
      </Link>
    </CardWrapper>
  );
};

export default FulltimeRecruitmentCard;
